import gql from 'graphql-tag';

export const IsEmailInBounceList = gql`
  query isEmailInBounceList($input: IsEmailInBounceListInput!) {
    isEmailInBounceList(input: $input) {
      isInBounceList
    }
  }
`;
